import { render, staticRenderFns } from "./ThanksPageTitle.vue?vue&type=template&id=94aedc1c&scoped=true&"
import script from "./ThanksPageTitle.vue?vue&type=script&lang=js&"
export * from "./ThanksPageTitle.vue?vue&type=script&lang=js&"
import style0 from "./ThanksPageTitle.vue?vue&type=style&index=0&id=94aedc1c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94aedc1c",
  null
  
)

export default component.exports